import { createContext, Dispatch, SetStateAction, useState } from 'react';

interface HoverColumnContextType {
	hoveredColId: string | undefined;
	setHoveredColId: Dispatch<SetStateAction<string | undefined>>;
}

export const HoverColumnContext = createContext<HoverColumnContextType>(
	{} as HoverColumnContextType
);

export const HoverContextProvider = ({ children }) => {
	const [hoveredColId, setHoveredColId] = useState<string>();

	return (
		<HoverColumnContext.Provider value={{ hoveredColId, setHoveredColId }}>
			{children}
		</HoverColumnContext.Provider>
	);
};
